{
  "common": {
    "close": "Fermer",
    "noRecordsFound": "Aucun résultat trouvé",
    "requiredField": "Ce champ est obligatoire"
  },
  "header": {
    "languageLabel": "Langue",
    "logoAlt": "Logo ARPM"
  },
  "toast": {
    "success": "Succès",
    "error": "Erreur",
    "warning": "Avertissement"
  },
  "create": {
    "heroEyebrow": "Créer un Rendez-vous",
    "heroTitle": "Page d'inscription au rendez-vous",
    "heroSubtitle": "Choisissez une date et une heure adaptées pour créer rapidement votre rendez-vous.",
    "panelTitle": "Détails du rendez-vous",
    "panelSubtitle": "Veuillez effectuer les sélections requises",
    "organizationLabel": "Organisation",
    "facilityLabel": "Établissement",
    "departmentLabel": "Service",
    "doctorLabel": "Médecin",
    "organizationPlaceholder": "Sélectionnez une organisation",
    "facilityPlaceholder": "Sélectionnez un établissement",
    "departmentPlaceholder": "Sélectionnez un service",
    "doctorPlaceholder": "Sélectionnez un médecin",
    "calendarTitle": "Sélectionnez la date et l'heure",
    "timeHeader": "Créneaux disponibles pour le {{date}}",
    "selectableTimes": "Créneaux Disponibles",
    "noAvailableTimes": "Aucun créneau disponible.",
    "createButton": "Créer le Rendez-vous",
    "toasts": {
      "missingCoreSelection": "La sélection de l'organisation, de l'établissement, du service et du médecin est obligatoire.",
      "missingAppointmentSelection": "Veuillez compléter la sélection de la date, de l'heure et du médecin.",
      "unavailableTime": "Le créneau sélectionné n'est plus disponible. Veuillez choisir un autre horaire.",
      "invalidDate": "Veuillez sélectionner une date valide.",
      "invalidTime": "Veuillez sélectionner une heure valide.",
      "created": "Rendez-vous créé.",
      "createdFallback": "Le rendez-vous a été créé avec succès.",
      "createError": "Une erreur est survenue lors de la création du rendez-vous."
    }
  },
  "preparation": {
    "heroEyebrow": "Inscription au rendez-vous",
    "heroTitle": "Formulaire de rendez-vous",
    "heroSubtitle": "Remplissez toutes vos informations pour créer rapidement votre rendez-vous.",
    "metaStepByStep": "Inscription Étape par Étape",
    "metaSecureData": "Données Sécurisées",
    "panelTitle": "Vos Informations",
    "panelSubtitle": "Veuillez remplir tous les champs ci-dessous",
    "personalInfoTitle": "Informations Personnelles",
    "addressInfoTitle": "Informations d'adresse",
    "tcLabel": "Patient ID",
    "tcPlaceholder": "Saisissez le Patient ID",
    "tcRequired": "Le Patient ID est obligatoire",
    "tcInvalid": "Veuillez vérifier l'exactitude des informations saisies.",
    "nameLabel": "Prénom",
    "namePlaceholder": "Saisissez votre prénom",
    "lastNameLabel": "Nom",
    "lastNamePlaceholder": "Saisissez votre nom",
    "birthDateLabel": "Date de naissance",
    "birthDatePlaceholder": "JJ/MM/AAAA",
    "genderLabel": "Sexe",
    "male": "Homme",
    "female": "Femme",
    "phoneLabel": "Numéro de téléphone",
    "phonePlaceholder": "5xx xxx xx xx",
    "emailLabel": "E-mail",
    "emailPlaceholder": "exemple@email.com",
    "emailInvalid": "Saisissez une adresse e-mail valide",
    "cityLabel": "Ville",
    "cityPlaceholder": "Sélectionnez une ville",
    "districtLabel": "District",
    "districtPlaceholder": "Sélectionnez un district",
    "neighborhoodLabel": "Quartier",
    "neighborhoodPlaceholder": "Quartier",
    "streetLabel": "Rue",
    "streetPlaceholder": "Rue",
    "buildingNoLabel": "N° de bâtiment",
    "buildingNoPlaceholder": "N° de bâtiment",
    "apartmentNoLabel": "N° d'appartement",
    "apartmentNoPlaceholder": "N° d'appartement",
    "nextButton": "Suivant",
    "checklistTitle": "Contrôle de préparation",
    "checklistSubtitle": "Les champs obligatoires seront cochés ci-dessous au fur et à mesure.",
    "checklistEmpty": "Aucun champ obligatoire n'a encore été rempli.",
    "fieldLabels": {
      "name": "Prénom",
      "lastName": "Nom",
      "tc": "Patient ID",
      "birthDate": "Date de naissance",
      "gender": "Sexe",
      "phone": "Numéro de téléphone",
      "email": "E-mail",
      "city": "Ville",
      "district": "District",
      "neighborhood": "Quartier",
      "street": "Rue",
      "buildingNo": "N° de bâtiment",
      "apartmentNo": "N° d'appartement"
    },
    "invalidEmailLabel": "E-mail (invalide)",
    "invalidBirthDateLabel": "Date de naissance (invalide)"
  },
  "consent": {
    "title": "Informations de consentement",
    "examination": "L'examen :",
    "paragraph1": "Avec notre assistante médicale, vous décidez vous-même des zones que vous souhaitez faire examiner.",
    "paragraph2": "Nous utilisons un système avancé capable de distinguer les lésions bénignes et malignes avec une grande fiabilité médicale. Les résultats sont évalués par l'un de nos dermatologues spécialisés en télé-dermatologie.",
    "singlePrice": "Le coût d'un dépistage du cancer de la peau est de 22,00 €.",
    "includedTitle": "Ce service comprend :",
    "items": [
      "Entretien initial avec l'assistante médicale",
      "Dépistage du cancer de la peau d'une lésion suspecte",
      "Rapport et diagnostic de notre dermatologue",
      "Informations sur la protection de votre peau"
    ],
    "multiplePrice": "Le coût de plusieurs dépistages du cancer de la peau est de 18,00 € par grain de beauté.",
    "absenceTitle": "En cas d'absence, une facture de non-présentation sera émise. Les exceptions suivantes s'appliquent :",
    "cancellation48": "Annulation 48 heures avant le rendez-vous : aucun frais.",
    "cancellation24": "Annulation 24 heures avant le rendez-vous : 15,00 € par examen.",
    "sameDay": "Annulation le jour du rendez-vous ou absence sans prévenir : 23,50 € par examen."
  },
  "success": {
    "title": "Merci !",
    "subtitle": "Votre demande a bien été reçue.",
    "message1": "Vous recevrez un SMS et un e-mail aux coordonnées que vous avez fournies.",
    "message2": "Si vous ne recevez pas l'e-mail, veuillez vérifier votre dossier spam."
  },
  "departments": {
    "Cardiology": {
      "label": "Cardiologie",
      "icon": "noun-cardiology-4072383"
    },
    "Nephrology": {
      "label": "Néphrologie",
      "icon": "noun-nephrology-7030227"
    },
    "Urology": {
      "label": "Urologie",
      "icon": "kidney"
    },
    "Pulmonology": {
      "label": "Pneumologie",
      "icon": "lung"
    },
    "Neurology": {
      "label": "Neurologie",
      "icon": "noun-neurology-5594376"
    },
    "Gastroenterology": {
      "label": "Gastro-entérologie",
      "icon": "gastroentology"
    },
    "Endocrinology": {
      "label": "Endocrinologie",
      "icon": "noun-endocrinology-7357860"
    },
    "Hematology": {
      "label": "Hématologie",
      "icon": "noun-hematology-7795354"
    },
    "Rheumatology": {
      "label": "Rhumatologie",
      "icon": "noun-rheumatology-8059647"
    },
    "Dermatology": {
      "label": "Dermatologie",
      "icon": "noun-dermatology-6378674"
    },
    "Infectious Diseases": {
      "label": "Maladies infectieuses",
      "icon": "noun-infectious-disease-7245345"
    },
    "Ophthalmology": {
      "label": "Ophtalmologie",
      "icon": "noun-ophthalmology-7215358"
    },
    "Otolaryngology": {
      "label": "ORL",
      "icon": "noun-otolaryngology-4840300"
    },
    "Orthopedics": {
      "label": "Orthopédie",
      "icon": "noun-orthopedics-6516988"
    },
    "Psychiatry": {
      "label": "Psychiatrie",
      "icon": "noun-psychology-6565274"
    },
    "Obstetrics Gynecology": {
      "label": "Gynécologie-obstétrique",
      "icon": "noun-obstetrics-and-gynecology-1191435"
    },
    "Oncology": {
      "label": "Oncologie",
      "icon": "noun-oncology-2312680"
    },
    "Transplantation": {
      "label": "Transplantation",
      "icon": "noun-transplant-2526273"
    },
    "Home Care": {
      "label": "Soins à domicile",
      "icon": "noun-home-care-7110960"
    }
  }
}
